<template>
  <div style="height: calc(100vh - 50px); overflow-y: auto; padding-right: 8px">
    <md-card id="reports" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">style</i>
        </div>
        <h4 class="title">DX Cards</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="currentSearchTxt" @keyup.enter="handleRefresh" />
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label for="currentType">Modality</label>
              <md-select v-model="modalityFilter" name="modalityFilter">
                <md-option v-for="(value, index) in modalities" :key="index" :value="value">
                  {{ value }}
                </md-option>
              </md-select>
            </md-field>

          </div>
          <div class="md-layout-item md-size-20" v-if="organisations.length > 1">
            <md-field>
              <label for="orgSelect">Organization</label>
              <md-select v-model="selectedOrganisationId" name="orgSelect">
                <md-option v-for="org in organisations" :key="org.orgId" :value="org.orgId">
                  {{ org.orgName }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item" style="align-items: end;" :class="[
            { 'md-size-40': organisations.length > 1 },
            { 'md-size-60': organisations.length <= 1 }
          ]">
            <div class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleRefresh">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter cards</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-primary" @click="handleRefresh">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
      </md-card-content>
    </md-card>

    <hr v-if="!isLoading">

    <ObservationsSection :mDxCards="filteredCards" :saveDxCard="saveDxCard" @delete="confirmDelete"
      @save-changes="saveChanges" />

    <div v-if="!filteredCards.length && !isLoading">
      No DX cards found for this search criteria
    </div>

    <loader v-if="isLoading" :is-visible="isLoading" />
  </div>
</template>

<script>
import ObservationsSection from "@/components/GlobeChek/dxCards/ObservationsSection.vue"
import Swal from "sweetalert2"
import { mapActions, mapGetters } from "vuex"
const loader = () => import("@/components/GlobeChek/loader.vue")
export default {
  components: {
    ObservationsSection,
    loader
  },
  data() {
    return {
      observations: [],
      filteredObservations: [],
      savedDxCard: {},
      cards: [],
      filteredCards: [],
      currentSearchTxt: '',
      modalities: [
        'All',
        'Anterior Segment OCT',
        'Corneal Topography',
        'External Photo',
        'Family History',
        'Fundus Photo',
        'Lens Status',
        'Macular OCT',
        'Medical History',
        'Optic Nerve OCT'
      ],
      modalityFilter: 'All',
      isLoading: false,
      organisations: JSON.parse(sessionStorage.getItem("organizations")),
      selectedOrganisationId: localStorage.getItem('currentOrgSelectedForFilters') != 'all' ? localStorage.getItem('currentOrgSelectedForFilters') : JSON.parse(sessionStorage.getItem("organizations"))[0].orgId,
    }
  },

  computed: {
    saveDxCard() {
      return this.savedDxCard
    }
  },
  mounted() {
    this.handleRefresh()
  },
  methods: {
    ...mapActions(["fetchDxCards"]),
    async handleSearch() {
      const searchFilter = this.currentSearchTxt;
      const modalityFilter = this.modalityFilter;
      localStorage.setItem("currentOrgSelectedForFilters", this.selectedOrganisationId)
      let response = this.cards.slice(0);
      if (searchFilter) {
        response = response.filter(i => {
          const searchText = ((i.observation || '') + (i.diagnoses && Array.isArray(i.diagnoses) ? i.diagnoses.join('') : '') + (i.recommendations && Array.isArray(i.recommendations) ? i.recommendations.join('') : '')).toLowerCase();
          return searchText.includes(searchFilter.toLowerCase());
        });
      }
      if (modalityFilter != 'All') {
        response = response.filter(i => i.modality === modalityFilter);
      }
      this.filteredCards = response;
    },
    handleRefresh() {
      this.fetchCards()
    },
    async fetchCards() {
      try {
        this.isLoading = true;
        if (!this.selectedOrganisationId) {
          this.cards = [];
          this.filteredCards = [];
          return;
        }
        this.cards = await this.$store.dispatch('fetchDxCards', {
          orgID: this.selectedOrganisationId,
          plain: true
        });
        // remove other findings from list
        this.cards = this.cards.filter(i => Array.isArray(i.diagnoses) && Array.isArray(i.recommendations))
        this.handleSearch();
      } catch (e) {
        console.error("Error to find DX Cards:", e);
      } finally {
        this.isLoading = false;
      }
    },
    saveChanges(newCard) {
      this.$store.dispatch("saveDxCard", newCard)
    },
    async confirmDelete(id) {
      const result = await Swal.fire({
        title: 'Confirm delete',
        text: 'Are you sure you want to delete this card?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel'
      });

      if (result.value) {
        this.deleteObservation(id).then(() => {
          this.searchObservations('');
        })
      }
    },
    async deleteObservation(id) {
      try {
        await this.$store.dispatch("deleteDxCard", id);
      } catch (error) {
        await Swal.fire({
          title: 'Delete failed',
          text: 'An error occurred while deleting'
        })
      }
    },
  }
}
</script>
<style lang="css" scoped></style>
